module.exports = __webpack_public_path__ + "img/10业务领域-img4.ada087c8.jpg";